<template>
  <div class="topic-bind-model-selected">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: left">
          <el-button type="primary" @click="delRows" :disabled="!rows.length">
            {{ $t('dms_topic_bind_model_selected.pi_liang_shan_chu') }}
          </el-button>
          <el-button type="primary" @click="pushAll">{{ !isPushAll ? $t('dms_topic_bind_model_selected.tui_song_quan_xuan') : $t('dms_topic_bind_model_selected.tui_song_fan_xuan')
          }}</el-button>
        </el-form-item>

        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('dms_topic_bind_model_selected.wmxmcwmxdm')" v-model="formSearch.search"
            @fetch="onSearch"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="getTableList" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_topic_bind_model_selected.bu_jian')">
          <el-input v-model="formSearch.component"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_topic_bind_model_selected.fen_lei')">
          <el-input v-model="formSearch.dataGroup"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_topic_bind_model_selected.TCPdai_ma')">
          <el-input v-model="formSearch.tcpDataCode"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <custom-table :height="tableHeight" :data="tableList" :column="tableColumn" :index="true" row-key="tslDataId"
      :tree-props="{ children: 'children' }" @filter="filterChange" @sort="sortChange" type="checkbox" v-model="rows"
      :slots="[
        'tcpDataCode',
        'topicTslClass',
        'topicTslType',
        'transferType',
        'transferExpression',
        'showOrder',
        'isPrimary',
        'isYearKey',
        'tcpDataLen',
        'tcpDataType',
        'isPushMq',
        'topicTslGroup',
        'tcpTopicTslClass',
        'dbUnit',
        'tcpDataUnit',
        'action',
      ]">
      <template v-slot:tcpTopicTslClass="scope">
        <custom-select v-model="scope.row.tcpTopicTslClass" code="iot_topic_tsl_class"
          :placeholder="getPlaceholder(scope.$index, formSearch.pageNum)"
          @input="updateRecordRow(scope.row, 'tcpTopicTslClass')"></custom-select>
      </template>
      <template v-slot:topicTslGroup="scope">
        <custom-select v-model="scope.row.topicTslGroup" code="iot_topic_tsl_group" :filterable="true"
          :placeholder="getPlaceholder(scope.$index, formSearch.pageNum)"
          @input="updateRecordRow(scope.row, 'topicTslGroup')"></custom-select>
      </template>
      <!-- 推送全选 -->
      <template v-slot:isPushMq="scope">
        <el-checkbox :true-label="1" :false-label="0" v-model="scope.row.isPushMq"
          @input="updateRecordRow(scope.row, 'isPushMq')" @change="syncIsPushAll"></el-checkbox>
      </template>
      <!-- TSL协议 -->
      <template v-slot:tcpDataCode="scope">
        {{ scope.row.tcpDataCode }}
      </template>
      <template v-slot:topicTslClass="scope">
        <custom-select v-model="scope.row.topicTslClass" :code="topicTslClassCode"
          :placeholder="getPlaceholder(scope.$index, formSearch.pageNum)"
          @input="updateRecordRow(scope.row, 'topicTslClass')"></custom-select>
      </template>
      <template v-slot:topicTslType="scope">
        <custom-select v-model="scope.row.topicTslType" :code="tslTypeCode"
          @input="updateRecordRow(scope.row, 'topicTslType')"></custom-select>
      </template>
      <!-- 协议类型 -->
      <template v-slot:tcpDataType="scope">
        {{ getDicValue('iot_tcp_data_type', scope.row.tcpDataType) }}
      </template>
      <template v-slot:isPrimary="scope">
        <el-checkbox :true-label="1" :false-label="0" v-model="scope.row.isPrimary"
          @input="updateRecordRow(scope.row, 'isPrimary')"></el-checkbox>
      </template>
      <template v-slot:isYearKey="scope">
        <el-checkbox :true-label="1" :false-label="0" v-model="scope.row.isYearKey"
          @input="updateRecordRow(scope.row, 'isYearKey')"></el-checkbox>
      </template>
      <template v-slot:showOrder="scope">
        <el-input v-model="scope.row.showOrder" :min="0" type="number"
          @input="updateRecordRow(scope.row, 'showOrder')"></el-input>
      </template>
      <!-- 数据转换 -->
      <template v-slot:transferType="scope">
        {{ getDicValue('iot_transfer_type', scope.row.transferType) }}
      </template>
      <!-- 转换表达式 -->
      <template v-slot:transferExpression="scope">
        {{ scope.row.transferExpression || '-' }}
      </template>
      <!-- 协议长度 -->
      <template v-slot:tcpDataLen="scope">
        {{ scope.row.tcpDataLen || '-' }}
      </template>
      <!-- 存储单位 iot_tsl_data_unit db_ratio -->
      <template v-slot:dbUnit="scope">
        <span>{{ getStockUnit(scope.row) }}</span>
      </template>
      <!-- 协议单位 iot_tsl_data_unit tcp_data_ratio -->
      <template v-slot:tcpDataUnit="scope">
        <span>{{ getProtocolUnit(scope.row) }}</span>
      </template>
      <template v-slot:action="scope">
        <span>
          <el-button v-if="!hasParent(scope.row)" type="text" size="mini" @click="del(scope.row)">{{ $t('Common.com_delete')
          }}</el-button>
        </span>
      </template>
    </custom-table>

    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize"
        @change="onPageChange"></custom-page>
    </div>
    <expression-setting-dialog v-if="showExpression" @close="showExpression = false" :code="expressionCode"
      :expression="expression" @confirm="expressionConfirm" :model="dialogModel2"></expression-setting-dialog>
  </div>
</template>

<script>
/** 已关联物模型 */
import apis from '@/utils/apis.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import { getTransferRelation, getShowSettingConfig, getShowInputConfig, showRelativeModelConfig } from '@/pages/dms/product/children/utils';
import expressionSettingDialog from '@/pages/dms/product/children/expression_setting_dialog.vue';
import mixins from './mixins';

export default {
  mixins: [resetFormSearchMixins, mixins],
  components: {
    expressionSettingDialog,
  },
  props: {
    protocolCode: String,
    topicId: String,
    tableHeight: String,
  },
  data() {
    return {
      tableCode: 'protocol_selected_model',
      rows: [],
      formSearch: {
        search: '',
        pageSize: 30,
        pageNum: 1,
        component: '',
        dataGroup: '',
        tcpDataCode: '',
      },
      tslId: '',
      tableList: [],
      totalRows: null,
      showExpression: false,
      expressionCode: '',
      topicTslClassCode: 'iot_topic_tsl_class',
      tslTypeCode: 'iot_topic_tsl_type',
      transferTypeCode: 'iot_transfer_type',
      expression: '',
      /** 无需转化： "0"  值到值："1" 倍率："2" 时间类型："3" 时间格式时分-数字 : "4"   */
      transferRelation: [],
      // 输入项，用于检测diff，同步缓存数据
      checkKeys: [
        'tcpDataCode',
        'topicTslClass',
        'topicTslType',
        'isPrimary',
        'isYearKey',
        'transferType',
        'transferExpression',
        'tcpDataLen',
        'showOrder',
        'isPushMq',
        'topicTslGroup',
        'tcpTopicTslClass',
        'dbUnit',
      ],
      record: [],
      dialogModel2: {},
      showInputConfig: {},
      showSettingConfig: {},
      isPushAll: false,
    };
  },
  computed: {
  },
  mounted() {
    this.getDictionary('iot_transfer_type_show,iot_transfer_expression_widget', (data) => {
      const transferRelationDic = data.iot_transfer_type_show;
      this.transferRelation = getTransferRelation(transferRelationDic);
      this.showInputConfig = getShowInputConfig(data.iot_transfer_expression_widget);
      this.showSettingConfig = getShowSettingConfig(data.iot_transfer_expression_widget);
    });
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    pushAll() {
      this.isPushAll = !this.isPushAll;
      this.tableList.forEach((row) => {
        row.isPushMq = this.isPushAll ? 1 : 0;
        this.updateRecordRow(row, 'isPushMq');
      });
    },
    showInput(row) {
      return showRelativeModelConfig(row, this.showInputConfig);
    },
    showSetting(row) {
      return showRelativeModelConfig(row, this.showSettingConfig);
    },
    onSizeChange() {
      this.formSearch.pageNum = 1;
      this.clearRecord();
      this.getTableList();
    },
    onSearch() {
      this.formSearch.pageNum = 1;
      this.clearRecord();
      this.getTableList();
    },
    // 将row转为标识，用于判断row是否已经被修改
    getRowTag(row) {
      const arr = [];
      this.checkKeys.forEach((key) => {
        const val = row[key];
        arr.push([key, val].join('='));
      });
      return arr.join(',');
    },
    copy(data) {
      return JSON.parse(JSON.stringify(data));
    },
    tslClassChange({ topicTslClass }, index) {
      for (let i = 0; i < this.tableList.length; i++) {
        const item = this.tableList[i];
        if (i > index) {
          if (!item.topicTslClass) {
            this.tableList[i].topicTslClass = topicTslClass;
          } else {
            return;
          }
        }
      }
    },
    dataFilter(list, row) {
      const ret = [];
      const typeConfig = this.transferRelation.find(item => item.types.includes(row.dataType));
      const transferList = list;
      transferList.forEach((item) => {
        if (typeConfig.values.includes(item.value)) {
          ret.push(item);
        }
      });
      return ret;
    },
    hasParent(row) {
      return row.dataParentId && row.dataParentId !== '0';
    },
    delRows() {
      this.$showConfirm(this.$t('dms_topic_bind_model_selected.nsfyplsc')).then(() => {
        this.$postJSON(apis.TopicCancelAssociateTsl, this.getDelReqData()).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.clearRecord();
          this.getTableList();
        });
      });
    },
    del(row) {
      this.$showConfirm(this.$t('dms_topic_bind_model_selected.nqdyscxzdwmxm')).then(() => {
        this.$postJSON(apis.TopicCancelAssociateTsl, this.getDelReqData(row)).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.removeRecord(row);
          this.getTableList();
        });
      });
    },
    removeRecord(row) {
      this.record = this.record.filter(item => item.topicTslDataId !== row.topicTslDataId);
    },
    getDelReqData(row) {
      return {
        topicId: this.topicId,
        tslId: row ? [row.tslId] : this.rows.map(item => item.tslId),
      };
    },
    seeExpression(row) {
      this.expressionCode = row.dicGroup;
      this.expression = row.transferExpression;
      this.dialogModel2.title = this.$t('dms_topic_bind_model_selected.zdzppb');
      this.showExpression = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      if (size !== this.formSearch.pageSize) {
        this.clearRecord();
      }
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;

      this.getTableList();
    },
    syncIsPushAll() {
      const tableList = this.tableList;
      const hasNoPush = tableList.some(item => !item.isPushMq);
      if (!hasNoPush) {
        this.isPushAll = true;
      } else {
        this.isPushAll = false;
      }
    },
    // 由于关联物模型时，重新获取的列表顺序和添加的不同，需要重新排列record 中的 index字段
    updateListIndex() {
      const tableList = this.tableList;
      const { pageNum, pageSize } = this.formSearch;
      const record = this.record;
      const baseNum = (pageNum - 1) * pageSize;
      const indexList = [];
      tableList.forEach((item, index) => {
        indexList.push({
          index: baseNum + index,
          topicTslDataId: item.topicTslDataId,
          tslName: item.tslName,
        });
      });


      indexList.forEach((item) => {
        const target = record.find(obj => obj.topicTslDataId === item.topicTslDataId);
        if (target) {
          target.index = item.index;
        }
      });

    },
    getTableList() {
      this.$getJSON(apis.TslTopicAssociatedList, this.getReqData()).then((res) => {
        const list = res.data.list;
        this.fixProperty(list);
        const { newData, oldData } = this.filterNewData(list);

        this.addRecord(newData, oldData.length);
        this.syncData(oldData, list);
        const treeNodes = this.nodeToTree(list);
        this.tableList = treeNodes;
        this.totalRows = res.data.total;
        if (newData.length) {
          this.updateListIndex();
        }
        this.syncIsPushAll();
      });
    },
    updateRecordRow(row, key) {
      const record = this.record.find(item => item.topicTslDataId === row.topicTslDataId);
      if (record) {
        record[key] = row[key];
        record.curTag = this.getRowTag(row);
      }
    },
    // 过滤出{newData, oldData}
    filterNewData(list) {
      const newData = [];
      const oldData = [];
      list.forEach((item) => {
        if (this.record.some(obj => obj.topicTslDataId === item.topicTslDataId)) {
          oldData.push(this.record.find(obj => obj.topicTslDataId === item.topicTslDataId));
        } else {
          newData.push(item);
        }
      });
      const ret = {
        newData,
        oldData,
      };
      return ret;
    },
    addRecord(list, oldDataLength) {
      const { pageSize, pageNum } = this.formSearch;
      const newData = this.copy(list);
      const baseNum = oldDataLength + (pageNum - 1) * pageSize;
      newData.forEach((item, index) => {
        const tag = this.getRowTag(item);
        item.oldTag = tag;
        item.curTag = tag;
        item.index = baseNum + index;
      });
      this.record.push(...newData);
    },
    syncRow(oldRow, newRow) {
      this.checkKeys.forEach((key) => {
        newRow[key] = oldRow[key];
      });
    },
    // 将oldData中的数据复制到list相同topicTslDataId的数据中
    syncData(oldData, list) {
      oldData.forEach((old) => {
        const cur = list.find(item => item.topicTslDataId === old.topicTslDataId);
        if (cur) {
          this.syncRow(old, cur);
        }
      });
    },
    getReqData() {
      return {
        ...this.formSearch,
        protocolCode: this.protocolCode,
        topicId: this.topicId,
      };
    },
    expressionConfirm(expression) {
      const item = this.tableList.find(obj => obj.tslId === this.tslId);
      if (item) {
        item.transferExpression = expression;
        this.updateRecordRow(item, 'transferExpression');
      }
    },
    getList() {
      return this.tableList;
    },
    getRecord() {
      return [...this.record];
    },
    clearRecord() {
      this.record = [];
    },
    transferTypeChange(row) {
      row.transferExpression = '';
    },
    settingExpression(row) {
      this.expressionCode = row.dicGroup;
      this.expression = row.transferExpression;
      this.dialogModel2.title = this.$t('dms_topic_bind_model_selected.zdzppb');
      this.showExpression = true;
      this.tslId = row.tslId;
    },
    // 同步子节点数据
    parentPropertyChange(row, property) {
      const val = row[property];
      if (row.children.length) {
        row.children.forEach((item) => {
          item[property] = val;
        });
      }
    },
    getChildNodes(list) {
      return this.$getJSON(apis.TslTopicPreAssociateList, {
        tslIds: list.map(item => item.tslId).join(','),
      });
    },
    nodeToTree(list, pid) {
      if (pid === undefined) {
        pid = '0';
      }
      const ret = [];
      list.forEach((item) => {
        if (item.dataParentId === pid) {
          ret.push(item);
        }
      });
      ret.forEach((item) => {
        item.children = this.nodeToTree(list, item.tslDataId);
      });
      return ret;
    },
    fixProperty(list) {
      const fixArr = [
        'topicTslClass',
        'tcpDataCode',
        'topicTslType',
        'transferType',
        'transferExpression',
        'isPrimary',
        'isYearKey',
        'showOrder',
        'tcpDataLen',
        'curTag',
        'index',
        'tcpDataType',
        'isPushMq',
        'topicTslGroup',
        'tcpTopicTslClass',
        'dbUnit',
        'tcpDataUnit',
      ];
      list.forEach((item) => {
        fixArr.forEach((key) => {
          if (item[key] === undefined) {
            if (key === 'transferType') {
              item[key] = '0';
            } else if (key === 'isPrimary') {
              item[key] = 0;
            } else if (key === 'isYearKey') {
              item[key] = 0;
            } else if (key === 'showOrder') {
              item[key] = 0;
            } else if (key === 'isPushMq') {
              item[key] = 0;
            } else {
              item[key] = '';
            }
          }
        });
      });
    },
    getPlaceholder(index, page) {
      if (page === 1 && index === 0) {
        return this.$t('Common.com_please_select');
      }
      return this.$t('dms_topic_bind_model_selected.mo_ren_tong_shang');
    },
  },
};
</script>

<style lang="scss">
.topic-bind-model-selected {
  .el-table {
    margin-top: 0 !important;
  }
}
</style>
